export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export type SortBy = string;

export interface SortProps {
  sortBy: SortBy;
  order: SortOrder;
}
